const initialState = {
  loadingState: 'initial',
  collection: [],
  pagination: {}
}

export default (state, action) => {
  switch (action.type) {
    case 'WORKFLOWS_EVENT_TYPES_REQUEST':
      return {
        ...state,
        loadingState: 'loading'
      }
    case 'WORKFLOWS_EVENT_TYPES_DONE': {
      const { payload: { collection, pagination } } = action

      return {
        ...state,
        loadingState: 'loaded',
        collection: [
          ...(state.collection || []),
          ...collection
        ],
        pagination
      }
    }
    case 'WORKFLOWS_EVENT_TYPES_FAIL':
      return {
        ...state,
        loadingState: 'error',
      }
    default:
      return {
        ...initialState,
        ...state
      }
  }
}
